import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import config from '@plone/volto/registry';

export const CookieBotAppExtra = (props) => {
  const domainGroupId = config.settings.cookiebotDomainGroupId;
  const language = useSelector((state) => state.intl.locale);

  /* istanbul ignore next */
  if (typeof window === 'undefined') {
    return null;
  }

  if (!domainGroupId || !document) {
    return null;
  }

  if (domainGroupId.length !== 36) {
    /* eslint-disable-next-line no-console */
    console.warn(
      `The cookie bot domain group id is ${domainGroupId.length} characters, instead it should be 36 characters!`,
    );
  }

  useEffect(() => {
    // Verificar si ya existe un script de CookieBot antes de insertar uno nuevo
    if (!document.getElementById('CookieBot')) {
      console.log('CookieBot: Añadiendo script -', new Date().toISOString());

      const script = document.createElement('script');
      script.setAttribute('id', 'CookieBot');
      script.setAttribute('src', 'https://consent.cookiebot.com/uc.js');
      script.setAttribute('data-cbid', domainGroupId);
      script.setAttribute('data-blockingmode', 'auto');
      script.setAttribute('type', 'text/javascript');
      if (language) {
        script.setAttribute('data-culture', language);
      }

      const head = document.querySelector('html > head');
      if (head) {
        head.insertBefore(script, head.firstChild);
        console.log('CookieBot: Script insertado correctamente');
      } else {
        console.error('CookieBot: No se encontró el elemento head');
      }
    } else {
      console.log('CookieBot: Script ya existe, saltando inserción');
    }
  }, [domainGroupId, language]);

  return <></>;
};